import React from 'react'
import '../../App.css';
import Footer from '../Footer';

function Shows() {
  return (
    <>
      <div className='store-header-image'> 
        <h1>Shows</h1>
      </div>

      <div className='main-content-container'>

      </div>

      <Footer />
    </>

  )
}

export default Shows
